(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@chakra-ui/react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("PaymentTokenForm", ["react", "@chakra-ui/react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["PaymentTokenForm"] = factory(require("react"), require("@chakra-ui/react"), require("react-dom"));
	else
		root["PaymentTokenForm"] = factory(root["react"], root["@chakra-ui/react"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__2363__, __WEBPACK_EXTERNAL_MODULE__9514__) => {
return 